import { gql } from "graphql-tag";

export default gql`
  mutation CreateLike($likeableId: Int!, $likeableType: String!) {
    likeResult: upsert_like(
      likeable_id: $likeableId
      likeable_type: $likeableType
    ) {
      likesCount: likes_count
      like {
        ...LikeFragment
      }
    }
  }
`;
